import {defineMessages} from 'react-intl';

const messages = defineMessages({
  activateAccount: {
    id: 'phoneActivationCodeView.activateAccount',
    defaultMessage: 'Activate Account'
  },
  activationCode: {
    id: 'phoneActivationCodeView.activationCode',
    defaultMessage: 'Activation Code'
  },
  newPassword: {
    id: 'ResetPassword.newPassword',
    defaultMessage: 'New password'
  },
  newPasswordConfirm: {
    id: 'confirmNewPassword',
    defaultMessage: 'Confirm new password'
  },
  submit: {
    id: 'common.actions.submit',
    defaultMessage: 'Submit'
  },
  passwordsDoNotMatch: {
    id: 'passwordsDoNotMatch',
    defaultMessage: 'Passwords do not match'
  },
  invalidPhoneNumberOrCode: {
    id: 'invalidPhoneNumberOrCode',
    defaultMessage: 'Invalid phone number or code. Request a new code if the problem persists'
  },
  thereWasAnError: {
    id: 'thereWasAnError',
    defaultMessage: 'There was an error processing your request, please try again later'
  },
  passwordSuccessfullySet: {
    id: 'passwordSuccessfullySet',
    defaultMessage: 'Your password has been successfully set'
  },
  returnToSignIn: {
    id: 'returnToSignIn',
    defaultMessage: 'Return to sign in'
  },
  phoneNumber: {
    id: 'phoneNumber',
    defaultMessage: 'Phone Number'
  }
});

export default messages;
